"use client";

import { c as _c } from "react/compiler-runtime";
import { Badge } from "../ui";
import React from "react";
import { RiCheckLine, RiCloseCircleLine, RiLightbulbLine, RiUserHeartLine } from "react-icons/ri";
import { cx } from "@/lib/tailwind-utils";
import { DoseManagementStatus, MedicationSummary } from "@/types/medication";

// Mirrors the task field controls (see task-inline-editors.tsx `StatusBadge` /
// `subtleTriggerClasses`) so the dose log status behaves and reads the same way
// a task's status field does.
export const DOSE_STATUS_CONFIG: Record<DoseManagementStatus, {
  label: string;
  icon: React.ElementType<{
    className?: string;
  }>;
  color: string;
}> = {
  [DoseManagementStatus.RECOMMENDED]: {
    label: "Recommended",
    icon: RiLightbulbLine,
    color: "text-accent-foreground"
  },
  [DoseManagementStatus.RECOMMENDED_PATIENT_SOURCED]: {
    label: "Recommended - Patient Sourced",
    icon: RiUserHeartLine,
    color: "text-accent-foreground"
  },
  [DoseManagementStatus.ACTIVE]: {
    label: "Active",
    icon: RiCheckLine,
    color: "text-status-success-text"
  },
  [DoseManagementStatus.DISCONTINUED]: {
    label: "Discontinued",
    icon: RiCloseCircleLine,
    color: "text-status-error-text"
  }
};
export function DoseStatusBadge(t0) {
  const $ = _c(8);
  const {
    medication
  } = t0;
  if (!medication.managementStatus) {
    return null;
  }
  const optConfig = DOSE_STATUS_CONFIG[medication.managementStatus];
  const T0 = optConfig.icon;
  let t1;
  if ($[0] !== optConfig.color) {
    t1 = cx("size-4", optConfig.color);
    $[0] = optConfig.color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== optConfig.icon || $[3] !== t1) {
    t2 = <T0 className={t1} />;
    $[2] = optConfig.icon;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== optConfig.label || $[6] !== t2) {
    t3 = <Badge>{t2}{optConfig.label}</Badge>;
    $[5] = optConfig.label;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}